module.exports = __webpack_public_path__ + "img/Group 4481.6ebc67c2.svg";